export default {
  id: 'posterList',
  code: 'CN',
  text: {
    '{ticket_amount}': '{ticket_amount}票',
    '{attendee_amount}': '{attendee_amount}人',
    'MMM DD, YYYY': 'YYYY年MM月DD日',
    'ddd, MMM DD YYYY': 'YYYY年MM月DD日 ddd',
    'Publish': '发布',
    'Published': '已发布',
    'You cannot edit poster that has been registered': '当前海报已经有人报名了，您无法再次编辑海报。',
    'Close': '下架',
    'Share': '分享',
    'Delete': '删除',
    'Registered: ': '已报名：',

  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/PosterList/locale.js